import React, { useEffect, useState, useRef } from "react";
import "../CSS/BannerSlider.css";

const banners = [
  
  process.env.PUBLIC_URL + "assets/banner111.png",
  process.env.PUBLIC_URL + "assets/banner112.png",
  process.env.PUBLIC_URL + "assets/banner113.png",
];

export default function DashboardTenagaKesehatan() {
  const [index, setIndex] = useState(0);
  const slideInterval = useRef(null);

  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startAutoPlay = () => {
    stopAutoPlay();
    slideInterval.current = setInterval(() => {
      setIndex((i) => (i + 1) % banners.length);
    }, 4500); 
  };

  const stopAutoPlay = () => {
    if (slideInterval.current) {
      clearInterval(slideInterval.current);
      slideInterval.current = null;
    }
  };

  const goTo = (i) => {
    setIndex(i);
    startAutoPlay();
  };


  return (
    <section className="tk-hero">
        <div
          className="tk-slider"
          onMouseEnter={stopAutoPlay}
          onMouseLeave={startAutoPlay}
        >
          {banners.map((src, i) => (
            <div
              key={i}
              className={`tk-slide ${i === index ? "active" : ""}`}
              style={{ backgroundImage: `url(${src})` }}
              aria-hidden={i !== index}
            />
          ))}

          {/* Tulisan di banner uyy */}
          <div className="tk-hero-overlay">
            <h1 className="tk-hero-title">
              End TB
              <br />
              Start Hope
            </h1>
            <p className="tk-hero-sub">
              TibiSmart unites care, knowledge, and action for a healthier future
            </p>
            <button className="tk-hero-cta">Learn More</button>
          </div>

          {/* dots */}
          <div className="tk-dots">
            {banners.map((_, i) => (
              <button
                key={i}
                className={`tk-dot ${i === index ? "active" : ""}`}
                onClick={() => goTo(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </section>
  );
}
